import { Grid, Typography, Container } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { useUserProfile } from '@backstage/plugin-user-settings';
import {
  UserSettingsSignInAvatar,
  UserSettingsMenu,
} from '@backstage/plugin-user-settings';

// You can further customize or split these sections as needed
export const CustomSettingsPage = () => {
  // Profile info
  const { profile, displayName } = useUserProfile();

  return (
    <Container maxWidth="lg" style={{ paddingTop: 32, paddingBottom: 32 }}>
      <Grid container spacing={3}>
        {/* Profile Section */}
        <Grid item xs={12}>
          <InfoCard title="Profile" variant="gridItem">
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <UserSettingsSignInAvatar size={96} />
              </Grid>
              <Grid item xs>
                <Typography variant="subtitle1">{displayName}</Typography>
                {profile.email && (
                  <Typography variant="body2" color="textSecondary">
                    {profile.email}
                  </Typography>
                )}
              </Grid>
              <Grid item>
                <UserSettingsMenu />
              </Grid>
            </Grid>
          </InfoCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CustomSettingsPage;
